import { Component, OnInit } from '@angular/core';
import { GlobalApiService } from 'src/app/services/global-api.service';

declare var update: any;
@Component({
  selector: 'app-mathjax-test',
  templateUrl: './mathjax-test.component.html',
  styleUrls: ['./mathjax-test.component.scss'],
})
export class MathjaxTestComponent implements OnInit {
  questionData: any;
  mathjaxContent: string = '';
  tikzContent: string = `\\begin{tikzpicture}
  \\draw (0,0) circle (1in);
\\end{tikzpicture}`;
  constructor(private globalApiService: GlobalApiService) {}

  ngOnInit(): void {
    this.getQuestion();
    setTimeout(() => {
      this.mathjaxContent = '<u><b>My text</b></u>';
    }, 5000);
    this.loadTikz();
  }

  loadTikz() {
    setTimeout(() => {
      new update(this.tikzContent, 'tikz-content');
    }, 4000);
  }

  getQuestion(): void {
    this.globalApiService.getQuestions(178).subscribe(
      (response: any) => {
        console.log(response);
        this.questionData = response;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
